import React from 'react';
import ReactDOM from 'react-dom';
import App from './main/App';
import * as Sentry from "@sentry/react";


// if(!import.meta.env.DEV && import.meta.env.VITE_APP_OPENMEI_SENTRY_DSN) {
// 	Sentry.init({
// 		dsn: import.meta.env.VITE_APP_OPENMEI_SENTRY_DSN,
// 		integrations: [
// 			Sentry.browserTracingIntegration(),
// 			Sentry.replayIntegration(),
// 		],
// 		tracesSampleRate: 1.0, //  Capture 100% of the transactions
// 		// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
// 		// Session Replay
// 		replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
// 		replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// 	});
// }

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log)) j
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
